import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const ReservationFormWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 14px;
  @media only screen and ${sizes.max991} {
    gap: 2.8vw;
  }
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(27)}
  line-height: 120%;
  color: ${colors.text.chambray};
  margin-bottom: 20px;
  @media only screen and ${sizes.max991} {
    margin-bottom: 4vw;
  }
`;

export const Subtitle = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(17)}
  line-height: 140%;
  color: ${colors.text.ebony};
  margin-top: 6px;
  :first-of-type {
    margin-top: 20px;
  }
  @media only screen and ${sizes.max991} {
    margin-top: 1.2vw;
    :first-of-type {
      margin-top: 4vw;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  @media only screen and ${sizes.max991} {
    gap: 4vw;    
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  flex: 1;
  > input {
    width: 100%;
  }
  @media only screen and ${sizes.max991} {
    gap: 0.8vw;
  }
`;

export const InputLabel = styled.div`
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  line-height: 120%;
  color: ${colors.text.gray};
`;

export const ErrorMessage = styled.span`
  width: 100%;
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  line-height: 120%;
  text-align: start;
  color: ${colors.error.sunsetOrange};
`;

export const ErrorMessageDoc = styled.span`
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  text-align: start;
  padding-top: 7px;
  color: ${colors.error.sunsetOrange};
`;
